var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 5L5 19",
    stroke: "#151719",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5L19 19",
    stroke: "#151719",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.97ca466c.svg";
export { ForwardRef as ReactComponent };